import { render, staticRenderFns } from "./ligSfCont.vue?vue&type=template&id=6bca0bb7&scoped=true&"
import script from "./ligSfCont.vue?vue&type=script&lang=js&"
export * from "./ligSfCont.vue?vue&type=script&lang=js&"
import style0 from "./ligSfCont.vue?vue&type=style&index=0&id=6bca0bb7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bca0bb7",
  null
  
)

export default component.exports